<div class="page-wrapper">
  <div class="header-banner">
    <img src="assets/images/wesure-header.svg" alt="weSure Header" />
  </div>

  <div class="chat-container">
    <div class="chat-header">
      <span>Surey AI</span>
    </div>

    <!-- Voice status bar — always visible when active -->
    <div class="voice-status-bar" *ngIf="micUsed && !isInitializing && (isListening || isSpeaking || isLoading || voiceError)">

      <ng-container *ngIf="isListening">
        <span class="dot dot-red"></span>
        <span class="voice-label listening-label">{{ voiceStatus || 'Listening… (speak now)' }}</span>
      </ng-container>

      <ng-container *ngIf="isSpeaking && !isListening">
        <span class="dot dot-blue"></span>
        <span class="voice-label speaking-label">Speaking…</span>
      </ng-container>

      <ng-container *ngIf="isLoading && !isListening && !isSpeaking">
        <span class="dot dot-orange"></span>
        <span class="voice-label processing-label">Processing…</span>
      </ng-container>

      <span *ngIf="voiceError" class="voice-error">⚠️ {{ voiceError }}</span>
    </div>

    <!-- Messages area -->
    <div class="chat-messages" #messagesContainer>
      <ng-container *ngFor="let msg of messages">
        <div *ngIf="msg.sender === 'bot'" class="message-row">
          <div class="message bot" [class.is-card]="msg.isCard" [innerHTML]="msg.html || msg.text"></div>
          <img src="assets/images/weSureLogo.png" class="bot-img" alt="weSure" />
        </div>
        <div *ngIf="msg.sender === 'user'" class="message user">
          {{ msg.text }}
        </div>
      </ng-container>

      <div *ngIf="isLoading" class="message-row">
        <div class="message bot typing">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>

    <!-- Input bar -->
    <div class="chat-input">
      <input
        type="text"
        [(ngModel)]="userInput"
        (keydown)="onKeyDown($event)"
        placeholder="Type a message…"
        [disabled]="isLoading || isListening"
      />

      <!-- Send button -->
      <button (click)="onSend()" [disabled]="isLoading || isListening" title="Send">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <line x1="22" y1="2" x2="11" y2="13"></line>
          <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
        </svg>
      </button>

      <!-- Mic button — always visible, no toggle needed -->
      <button
        class="mic-btn"
        [class.mic-recording]="isListening"
        [class.mic-speaking]="isSpeaking"
        (click)="isListening ? stopRecording() : startListening()"
        [disabled]="isLoading || isInitializing"
        title="{{ isListening ? 'Tap to stop' : isSpeaking ? 'Tap to interrupt' : 'Tap to speak' }}"
      >
        <svg *ngIf="!isListening" width="20" height="20" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
          <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
          <line x1="12" y1="19" x2="12" y2="23"/>
          <line x1="8"  y1="23" x2="16" y2="23"/>
        </svg>
        <svg *ngIf="isListening" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <rect x="6" y="6" width="12" height="12" rx="2"/>
        </svg>
      </button>
    </div>
  </div>
</div>